import React from "react";
import { Link } from "react-router-dom";
import { FaEye, FaEdit, FaTrash } from "react-icons/fa";

export default function ConfigProfileRow({ profile, isAdmin, onView, onEdit, onDelete, isNanoCmd }) {
  const displayName = isNanoCmd ? profile.name : profile.PayloadDisplayName;
  const description = isNanoCmd ? "NanoCMD" : profile.PayloadDescription;
  const organization = isNanoCmd ? (profile.identifier || "—") : profile.PayloadOrganization;
  const version = isNanoCmd ? "—" : (profile.PayloadVersion ?? "—");

  const profileWithFlag = isNanoCmd ? { ...profile, isNanoCmd: true } : profile;

  return (
    <tr>
      <td>
        {displayName}
        {isNanoCmd && (
          <span
            className="badge rounded-pill bg-info ms-1"
            style={{ fontSize: "0.65rem", fontWeight: 500 }}
            title="NanoCMD-Profil"
          >
            NC
          </span>
        )}
      </td>
      <td>{description}</td>
      <td>{organization}</td>
      <td>{version}</td>
      {isAdmin && (
        <td className="text-end">
          {onView && (
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary me-1"
              onClick={() => onView(profileWithFlag)}
              title="Inhalt anzeigen"
            >
              <FaEye />
            </button>
          )}
          {!isNanoCmd && profile._id && (
            <Link
              to={`/profiles/editor/${profile._id}`}
              className="btn btn-sm btn-outline-primary me-1"
              title="Im Editor öffnen"
            >
              Editor
            </Link>
          )}
          {onEdit && (
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary me-1"
              onClick={() => onEdit(profileWithFlag)}
              title="Bearbeiten"
            >
              <FaEdit />
            </button>
          )}
          {onDelete && (
            <button
              type="button"
              className="btn btn-sm btn-outline-danger"
              onClick={() => onDelete(profile)}
              title="Löschen"
            >
              <FaTrash />
            </button>
          )}
        </td>
      )}
    </tr>
  );
}
